export const rootElementId = 'footer-container';
export const accountSettingsLanguageSelectorId = 'account-settings-language-selector';

export const translationConfig = {
  common: [],
  feature: 'CommonUI.Features'
};
